import { store } from '../store/store';
import { logout } from '../store/slices/authSlice';

const AUTH_KEY = 'auth_v1';
const TAB_AUTH_BINDING_KEY = 'meetingTabSessionId';

// 1. Logout செய்யும் போது வைத்துக்கொள்ள வேண்டிய keys
const DEVICE_KEYS = [
  'deviceId',
  'deviceSig',
  'rzp_checkout_anon_id',
  'rzp_device_id',
  'shep_device_id',
  'shep_install_reported',
  '_grecaptcha'
];

// 2. Meeting End ஆகும் போது வைத்துக்கொள்ள வேண்டிய keys
const MEETING_END_KEYS = [
  ...DEVICE_KEYS,
  'accessToken',
  'lastActivity',
  'refreshToken',
  'rememberEmail',
  'token',
  'user',
  'auth_v1', // Login state-ஐ தக்கவைக்க இது அவசியம் 
  'sessionId' // Login state-ஐ தக்கவைக்க இது அவசியம் 
];

export const persistAuth = (authData, remember = true) => {
  const storage = remember ? localStorage : sessionStorage;
  const staleStorage = remember ? sessionStorage : localStorage;
  const authToSave = {
    user: authData.user,
    token: authData.token,
    sessionId: authData.sessionId || '',
    persistedAt: Date.now(),
  };
  const userId = authToSave.user?._id || authToSave.user?.id || '';
  storage.setItem(AUTH_KEY, JSON.stringify(authToSave));
  storage.setItem('accessToken', authToSave.token || '');
  storage.setItem('token', authToSave.token || '');
  storage.setItem('sessionId', authToSave.sessionId);
  storage.setItem('userId', String(userId));

  // A new login must not coexist with an older tab-scoped identity in this
  // same tab. Otherwise the meeting socket can authenticate with one token
  // while REST and Redux use another.
  [AUTH_KEY, 'accessToken', 'token', 'sessionId', 'userId'].forEach((key) =>
    staleStorage.removeItem(key)
  );
  staleStorage.removeItem(TAB_AUTH_BINDING_KEY);
  if (!remember && authToSave.sessionId) {
    sessionStorage.setItem(
      TAB_AUTH_BINDING_KEY,
      String(authToSave.sessionId)
    );
  }
};

export const loadPersistedAuth = () => {
  // Session auth belongs to this tab and wins over shared remembered auth.
  const raw = sessionStorage.getItem(AUTH_KEY) || localStorage.getItem(AUTH_KEY);
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
};

// --- LOGOUT CLEANUP (Updated) ---
export const clearPersistedAuth = () => {
  const savedData = {};

  // தேவையான values-ஐ மட்டும் தனியாக எடுத்து வைத்துக்கொள்கிறோம்
  DEVICE_KEYS.forEach((key) => {
    if (localStorage.getItem(key) !== null) {
      savedData[key] = localStorage.getItem(key);
    }
  });

  // அனைத்தையும் அழிக்கிறோம்
  localStorage.clear();
  sessionStorage.clear();

  // எடுத்து வைத்த values-ஐ மீண்டும் செட் செய்கிறோம்
  Object.keys(savedData).forEach((key) => {
    localStorage.setItem(key, savedData[key]);
  });
};

// மீட்டிங் முடிந்தவுடன் நீக்கப்பட வேண்டிய keys
const MEETING_DATA_TO_REMOVE = [
  'roomId',
  'statusget',
  'islost',
  'rejoin-room',
  'lastRoomId',
  'meetingEnd',
  'isHost',
  'originalHost',
  'participantsGet',
  'hostGet'
];

export const clearMeetingEndStorage = () => {
  // 1. Array-ல் உள்ள Static Keys-ஐ அழிக்க (பழைய code)
  MEETING_DATA_TO_REMOVE.forEach(key => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });

  // 2. 'meet-lock' என்று ஆரம்பிக்கும் Dynamic Keys-ஐ அழிக்க
  
  // LocalStorage-ல் தேடி அழிக்க
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('meet-lock:')) {
      localStorage.removeItem(key);
    }
  });

  // SessionStorage-ல் தேடி அழிக்க (தேவைப்பட்டால்)
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith('meet-lock:')) {
      sessionStorage.removeItem(key);
    }
  });
};

export const getPersistedSessionId = () =>
  // The tab-scoped meeting session is authoritative. Another meeting tab may
  // legitimately update the shared localStorage fallback.
  sessionStorage.getItem('sessionId') || localStorage.getItem('sessionId') || '';

export const getAuthTokenFromStorage = () => {
  const cached = loadPersistedAuth();
  return cached?.token || '';
};

export const getUserIdFromStorage = () => {
  const cached = loadPersistedAuth();
  return cached?.user?.id || cached?.user?._id || '';
};

export const logoutUser = () => {
  const sessionId = getPersistedSessionId();
  store.dispatch(logout(sessionId));
};
